module.exports = __webpack_public_path__ + "assets/img/header_copy.6ec28f60.svg";